<div id="main-content" class="wrapper has-padding margin-height zoom-margin">

    <object data="assets/Criminal Record Certificate Request - France.pdf" width="100%" height="700"
        type="application/pdf" title="Criminal Record Certificate Request - France">
        <embed src="assets/Criminal Record Certificate Request - France.pdf" type="application/pdf" width="100%"
            height="700" title="Criminal Record Certificate Request - France" />
    </object>
</div>